// ユーザー編集画面: 退校日が設定されている場合は更新前に確認ダイアログを出す
document.addEventListener('DOMContentLoaded', function() {
    const form = document.getElementById('user-edit-form');
    if (!form) {
        return;
    }

    form.addEventListener('submit', function(event) {
        const dropoutDate = form.querySelector('[name="dropout_date"]');
        if (!dropoutDate || dropoutDate.value === '') {
            return;
        }

        if (!confirm('退校日が設定されると、退校日翌日以降に設定されている対面指導の日程は削除されます。更新してよろしいでしょうか？')) {
            event.preventDefault();
        }
    });
});
